import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { MessageService } from '../../services';
import { ConditionalRender } from '../formControls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReply, faUsers, faPaperclip } from '@fortawesome/free-solid-svg-icons';

const formatDate = (date) => {
    const dt = moment(date)
    let returnVal = '';
    const currDate = moment();
    const same = dt.isSame(currDate, 'day');
    if (same) {
        returnVal = 'at ' + dt.format('h:mm A') + ' today';
    } else {
        const yearSame = dt.isSame(currDate, 'year');
        if (yearSame) {
            returnVal = 'on ' + dt.format('M/D') + ' at ' + dt.format('h:mm A');
        } else {
            returnVal = 'on ' + dt.format('M/D/YY') + ' at ' + dt.format('h:mm A');
        }
    }
    return returnVal;
}

const limitStringLen = (str, maxLength = 20) => {
    //const re = /(?:\.([^.]+))?$/;
    const split = str.split('.');
    const ext = split.pop();
    let tmpStr = split.join();
    if (tmpStr.length > maxLength) {

        tmpStr = tmpStr.slice(0, (maxLength / 2)) + '...' + tmpStr.slice(tmpStr.length - (maxLength / 2) + 1);
        return tmpStr + '.' + ext;
    }
    return str;
}

const formatRead = (text, read) => {
    if (read) {
        return text;
    } else {
        return <b>{text}</b>
    }
}

const formatTextToHtml = (text) => {
    var split = text.split('\n');
    var result = split.map(part => part.length > 0 ? <p className="mb-2">{part}</p> : '');
    return result;
}

const MessageList = (props) => {
    const [messageList, setMessageList] = useState([]);

    useEffect(() => {
        if (props.message && props.message.id > 0) {
            // get root message
            const message = <MessageListItem key="mainMessage" currentUserId={props.currentUserId} message={props.message} />
            // get responses
            const messages = props.message?.responses?.length > 0 ?
                props.message.responses.map((msg, idx) => {
                    return <MessageListItem key={idx} currentUserId={props.currentUserId} message={msg} />
                }) : []
            // add root message to start of messages;
            messages.unshift(message);

            setMessageList(messages);
        } else {
            setMessageList([<div>No messages</div>]);
        }

    }, [props.message])

    return (
        <div className="message-container clearfix">
            {messageList}
        </div>
    )
}

export default MessageList;

const MessageListItem = (props) => {
    const message = props.message;
    const authorPosted = message?.sentFromUserId === props.currentUserId;
    const className = authorPosted ? "message-item message-item-self" : "message-item";
    return (
        <div className={className} key={props.key}>
            <div className="d-flex align-items-center font-weight-bold">
                <div className="mr-auto">{authorPosted ? 'You ' : message.sentFromUser?.fullName + ' from ' + message.sentFromUser?.accountName} {message.parentId ? ' posted ' : ' replied '} {formatDate(message.sentOn)}</div>
            </div>
            <div>
                {formatTextToHtml(message.message)}
            </div>
            <MessageAttachmentList attachments={message.attachments} />
        </div>
    )
}

const MessageAttachmentList = (props) => {

    const downloadFile = async (messageId, fileId, contentType, fileName) => {
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        const messageService = new MessageService();
        var response = await messageService.getFile(messageId, fileId);

        if (response.result) {
            var blob = new Blob([response.model], { type: contentType });
            var link = document.createElement("a");
            link.setAttribute("href", response.model);
            link.style.display = "none";
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } else {
            window.alert('Error downloading file.');
        }
    }

    return (
        <ConditionalRender visible={props.attachments && props.attachments.length > 0}>            
            <div className="d-flex">
                {
                    props.attachments.map((att, idx) => <Button size="sm" key={idx} variant="link" className="success" onClick={() => downloadFile(att.messageId, att.id, att.contentType, att.fileName)} key={idx}><FontAwesomeIcon icon={faPaperclip} /> {limitStringLen(att.fileName, 20)}</Button>)
                }
            </div>
        </ConditionalRender>
    )
}